<template>
	<div class="chargingRecord">
		<div class="itemTitleBox disStart">
			<span class="title" :class="{active:active==0}" @click="changeList(0)">充电记录</span>
			<span class="linBox"></span>
			<span class="title" :class="{active:active==1}" @click="changeList(1)">卡充电记录</span>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disStart searchLeft">

					<div class="myinputBox">
						<el-input clearable v-model="searchObj.orderId" placeholder="请输入订单号"></el-input>
					</div>
					<div class="myinputBox" v-if="active==1">
						<el-input clearable v-model="searchObj.cardNumber" placeholder="请输入卡号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.transactionId" placeholder="请输入交易单号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
						<!-- <el-select clearable v-model="searchObj.communityName" allow-create filterable remote
							reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
							<el-option v-for="item in restaurants" :key="item.communityId" :label="item.communityName"
								:value="item.communityId">
							</el-option>
						</el-select> -->
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityEquipmentNo"
							@change="changeCommunityEquipmentPort" placeholder="请输入设备编号"></el-input>
					</div>
					<div class="myinputBox">
						<el-input clearable v-model="searchObj.communityEquipmentPort" type="Number"
							:disabled="!searchObj.communityEquipmentNo" placeholder="请输入端口"></el-input>
					</div>

					<div class="myinputBox">
						<el-select clearable v-model="searchObj.orderStatus" slot="prepend" placeholder="请选择充电情况">
							<el-option v-for="(item,inx) in orderStatusList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<div class="myinputBox" v-if="!($serviceProviderId)">
						<el-select clearable v-model="searchObj.serviceProviderId" slot="prepend" placeholder="请选择运营商">
							<el-option v-for="(item,inx) in serviceList" :key="inx" :label="item.serviceProviderName"
								:value="item.serviceProviderId"></el-option>
						</el-select>
					</div>

					<div class="myinputBox">
						<el-input clearable v-model="searchObj.loginId" placeholder="请输入用户名"></el-input>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
							placeholder="结束时间">
						</el-date-picker>
						<!-- <el-date-picker v-model="searchObj.searchData" type="daterange" range-separator="~"
							value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker> -->
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
					<el-button type="success" @click="exportData">导出</el-button>
				</div>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%" v-if="active!=1">
						<el-table-column type="index" label="序号" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="userName" label="用户名">
							<template slot-scope="scope">
								<span v-if="scope.row.cardUserName">{{scope.row.cardUserName}}</span>
								<span v-else>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="充电地址">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentPort" label="端口" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="startTime" label="充电时间" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="payType" label="支付方式">
							<template slot-scope="scope">
								<span>{{scope.row.payType==1?"微信支付":scope.row.payType==2?"余额支付":""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderStatus" label="充电情况">
							<template slot-scope="scope">
								<span>{{scope.row.orderStatus==1?"充电中":scope.row.orderStatus==2?"充电结束":scope.row.orderStatus==0?"未充电":""}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="communityEquipmentPortPower" label="最大功率(W)">
							<template slot-scope="scope">
								<span @click="showPower(scope.row)"
									class="clickUndline">{{scope.row.communityEquipmentPortPower}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="timeStr" label="实际时长"></el-table-column>
						<el-table-column show-overflow-tooltip prop="realConsumeAmount"
							label="实际营收(元)"></el-table-column>
						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
									<div class="pupBox">
										<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,2)"
											v-if="scope.row.orderStatus==2 && (scope.row.manualRefundFlag==='0'||scope.row.manualRefundFlag===0)">退款</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,3)"
											v-if="scope.row.orderStatus==1">结束订单</span>
									</div>
									<div slot="reference" class="itemRight listIcon"></div>
								</el-popover>
							</template>
						</el-table-column>
					</el-table>
					<el-table :data="tableData" stripe style="width: 100%" v-else>
						<el-table-column type="index" label="序号" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="userName" label="用户名">
							<template slot-scope="scope">
								<span v-if="scope.row.cardUserName">{{scope.row.cardUserName}}</span>
								<span v-else>{{scope.row.loginId?((scope.row.loginId).slice(10)):""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="cardNumber" label="卡号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communitySiteName" label="充电地址">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityEquipmentPort" label="端口" width="55">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="startTime" label="充电时间" width="150">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="payType" label="支付方式" v-if="active!=1">
							<template slot-scope="scope">
								<span>{{scope.row.payType==1?"微信支付":scope.row.payType==2?"余额支付":""}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="orderStatus" label="充电情况">
							<template slot-scope="scope">
								<span>{{scope.row.orderStatus==1?"充电中":scope.row.orderStatus==2?"充电结束":scope.row.orderStatus==0?"未充电":""}}</span>
							</template>
						</el-table-column>
						<el-table-column prop="communityEquipmentPortPower" label="最大功率(W)">
							<template slot-scope="scope">
								<span @click="showPower(scope.row)"
									class="clickUndline">{{scope.row.communityEquipmentPortPower}}</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="timeStr" label="实际时长"></el-table-column>
						<el-table-column show-overflow-tooltip prop="realConsumeAmount"
							label="实际营收(元)"></el-table-column>
						<el-table-column prop="operate" label="操作" width="60">
							<template slot-scope="scope">
								<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
									<div class="pupBox">
										<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,2)"
											v-if="scope.row.orderStatus==2 && (scope.row.manualRefundFlag==='0'||scope.row.manualRefundFlag===0)">退款</span>
										<span class="hoverClass" @click.stop="itemClick(scope.row,3)"
											v-if="scope.row.orderStatus==1">结束订单</span>
									</div>
									<div slot="reference" class="itemRight listIcon"></div>
								</el-popover>
							</template>
						</el-table-column>
					</el-table>

				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 	<el-dialog title="最大充电功率" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="visibleShow"
			width="60%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="最大输出功率" prop="maxNum">
								<div class="myinputBox">
									<el-select clearable v-model="creatObj.maxNum" slot="prepend"
										placeholder="请选择最大输出功率">
										<el-option v-for="(item,inx) in maxList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="visibleShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog> -->
		<el-dialog :title="mydialogTitle" center class="mydialog" :visible.sync="dialogVisible1" width="70%">
			<div class="dialogBox ">
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>交易单号：{{creatObj.transactionId}}</span>
						<span>订单号：{{creatObj.orderId}}</span>
						<span>用户名：{{creatObj.loginId}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>设备编号：{{creatObj.communityEquipmentNo}}</span>
						<span>端口：{{creatObj.communityEquipmentPort}}</span>
						<span>所属社区：{{creatObj.communityName}}</span>

					</div>
					<div class="itemBox itemBox1 disStart">
						<span>充电地址：{{creatObj.communitySiteName}}</span>
						<span>运营商：{{creatObj.equipmentServiceProvider}}</span>
						<span>充电时间：{{creatObj.startTime}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>结束时间：{{creatObj.realEndTime}}</span>
						<span>充电时长(小时)：{{creatObj.rechargeTime}}</span>
						<span>充电最大功率(W)：{{creatObj.communityEquipmentPortPower}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>实际时长：{{creatObj.timeStr}}</span>
						<span>充电金额(元)：{{creatObj.orderAmount}}</span>
						<span>退款(元)：{{creatObj.returnConsumeAmount}}</span>

					</div>
					<div class="itemBox itemBox1 disStart ">
						<span>实际营收(元)：{{creatObj.realConsumeAmount}}</span>
						<span>充电情况：
							<span
								:class="creatObj.orderStatus==1?'green':creatObj.orderStatus==2?'red':creatObj.orderStatus==0?'grey':''">{{creatObj.orderStatus==1?"充电中":creatObj.orderStatus==2?"充电结束":creatObj.orderStatus==0?"未充电":""}}</span>
						</span>
						<span>结束理由：{{creatObj.endReason}}</span>
					</div>
					<div class="itemBox itemBox1 disStart ">

						<span>退款理由：{{creatObj.refundReason}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer diabtnBox">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog :title="title" center class="mydialog" :close-on-click-modal="NOfalse"
			:visible.sync="showPowerEcharts" width="90%">
			<div class="changeBtnBox disStart">
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==1}" @click="typeActive=1">功率</span>
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==2}" @click="typeActive=2">电压</span>
				<span class="changeBtnItem disCenter" :class="{changeAct:typeActive==3}" @click="typeActive=3">电流</span>
			</div>
			<div class="statisticalRight" id="myEcharts2"></div>
		</el-dialog>
		<el-dialog title="退款" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="timeShow"
			width="40%">
			<el-form :model="creatObj" :rules="rules" ref="ruleForm4" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox4">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="充电时长(分钟)" prop="realTime">
								<div class="myinputBox">
									<el-input @input="numberChange(creatObj.realTime,50)" v-model="creatObj.realTime"
										type="Number" placeholder="请输入充电时长"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="timeShow=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm4')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>

</template>

<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "chargingRecord",
		components: {},
		data() {
			return {
				NOfalse: false,
				visibleShow: false,
				dialogVisible1: false,
				showPowerEcharts: false,
				typeActive: 1,
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				title: "功率曲线图",
				creatObj: {
					maxNum: 600,
				},
				maxList: [{
					text: "700",
					value: 700
				}, {
					text: "800",
					value: 800
				}, {
					text: "900",
					value: 900
				}, {
					text: "1000",
					value: 1000
				}],
				end: 80,
				min: 200,
				tableData: [],
				communityList: [],
				stationList: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					searchData: [],
					pageSize: 8, //当前页个数
					communityName: "", //社区名
					communitySiteId: "", //社区站点id
					search: "", //搜索
					serviceProviderId: "", //运营商id
					startTime: "", //开始时间（yyyy-MM-dd）
					endTime: "" //结束时间（yyyy-MM-dd）
				},
				restaurants: [],
				serviceList: [],
				options: [],
				orderStatusList: [{
						text: "未充电",
						value: 0
					},
					{
						text: "充电中",
						value: 1
					},
					{
						text: "充电结束",
						value: 2
					}
				],
				rules: {
					maxNum: [{
						required: true,
						message: '请选择最大输出功率',
						trigger: 'change'
					}],
					realTime: [{
						required: true,
						message: '请输入充电时长',
						trigger: 'blur'
					}],
				},
				creatObj: {},
				timeShow: false,
				active: 0,
				mydialogTitle: "充电记录",
				echartsObj: {}
			}
		},
		watch: {
			typeActive(n) {
				this.showEchart(n)
			}
		},
		mounted() {
			if (this.$route.query.communityEquipmentNo) {
				console.log(this.$route.query)
				this.$set(this.searchObj, "communityEquipmentNo", this.$route.query.communityEquipmentNo)
			}
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]
			this.$nextTick(() => {
				this.getData()
				this.selectParamConfigByCode()
			})

		},
		methods: {
			changeCommunityEquipmentPort(e) {
				if (e) {

				} else {
					this.$set(this.searchObj, "communityEquipmentPort", "")
				}
			},

			changeList(n) {
				this.active = n
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})

			},
			showPower(obj, n) {
				this.title = "充电曲线图（" + obj.communityName + "-" + obj.communitySiteName + "-" + obj.communityEquipmentNo +
					"-插座" + obj.communityEquipmentPort + "）"

				this.$api.listPowerList({
					orderId: obj.orderId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (res.obj && res.obj.length > 0) {
							this.showPowerEcharts = true
							if (res.obj.length > 10 && res.obj.length <= 20) {
								this.$set(this, "end", 100)
							} else if (res.obj.length > 20) {
								this.$set(this, "end", 120)
							} else {
								this.$set(this, "end", 100)
							}
							this.$set(this, "echartsObj", res.obj)

							this.$nextTick(() => {
								this.showEchart(1)
							})
						} else {
							this.$message('暂无充电功率记录');
						}

					}
				})

			},
			showEchart(n) {
				let item = {
					xDate: [],
					data: []
				}
				let arr = []
				let legen = ["充电功率"]
				let unit = "功率:W"
				if (n == 1) {
					unit = "功率:W"
					legen[0] = "充电功率"
				} else if (n == 2) {
					unit = "电压:V"
					legen[0] = "充电电压"
				} else if (n == 3) {
					unit = "电流:mA"
					legen[0] = "充电电流"
				}
				for (let k of this.echartsObj) {
					item.xDate.push(k.createTime)
					if (n == 1) {
						item.data.push(k.power)
						arr.push(k.power)
					} else if (n == 2) {
						item.data.push(k.voltage)
						arr.push(k.voltage)
					} else if (n == 3) {
						item.data.push(k.elecCurrent)
						arr.push(k.elecCurrent)
					}

				}
				arr.sort((a, b) => {
					return a - b
				})
				this.$set(this, "min", arr[0])
				let that = this
				let getchart = that.$echarts.init(document.getElementById('myEcharts2'));
				getchart.clear()
				var option = {
					tooltip: {
						trigger: "axis",
						// valueFormatter: function(value) {
						// 	return value + "W"
						// }
					},
					grid: {
						top: "8%",
						left: "3%",
						right: "4%",
						bottom: "8%",
						containLabel: true,
					},
					lenged: {
						data: legen
					},
					xAxis: [{
						type: "category",
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},
						splitLine: {
							show: false,
						},

						splitArea: {
							show: false,
						},
						axisLabel: {
							// interval:0,
							formatter: function(params) {
								var newParamsName = "";
								var paramsNameNumber = params.length;
								var provideNumber = 10; //一行显示几个字
								var rowNumber = Math.ceil(
									paramsNameNumber / provideNumber
								);
								if (paramsNameNumber > provideNumber) {
									for (var p = 0; p < rowNumber; p++) {
										var tempStr = "";
										var start = p * provideNumber;
										var end = start + provideNumber;
										if (p === rowNumber - 1) {
											tempStr = params.substring(
												start,
												paramsNameNumber
											);
										} else {
											tempStr =
												params.substring(start, end) +
												"\n";
										}
										newParamsName += tempStr;
									}
								} else {
									newParamsName = params;
								}
								return newParamsName;
							}
						},
						data: item.xDate,
					}, ],
					yAxis: [{
						name: unit,
						type: "value",
						min: that.min,
						axisLine: {
							lineStyle: {
								color: "#90979c",
							},
						},

					}, ],
					dataZoom: [{
							show: true,
							height: 30,
							xAxisIndex: [0],
							bottom: -60,
							start: 0,
							end: that.end,
						},
						{
							type: "inside",
							show: true,
							height: 15,
							start: 1,
							end: 50,
						},
					],
					series: [{
						name: legen[0],
						type: "line",
						smooth: true, //是否平滑曲线显示
						symbol: 'circle', // 默认是空心圆（中间是白色的），改成实心圆
						symbolSize: 10,
						lineStyle: {
							normal: {
								color: "#03adac", // 线条颜色
							},
						},
						data: item.data,
					}, ],
				};

				getchart.setOption(option);
			},
			exportData() {
				let obj = {
					communityName: this.searchObj.communityName,
					communitySiteId: this.searchObj.communitySiteId,
					search: this.searchObj.search,
					serviceProviderId: this.searchObj.serviceProviderId,
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime, //结束时间
					communityEquipmentNo: this.searchObj.communityEquipmentNo,

				}
				this.$api.exportRechargeRecord(obj, "充电记录").then((res) => {
					if (res.returnCode == 200) {

					}
				})
			},
			itemClick(obj, n) {
				let that = this
				this.$set(this, "creatObj", obj)
				if (n == 1) {
					this.$nextTick(() => {
						if (this.active == 1) {
							this.mydialogTitle = "卡充电记录(卡号：" + (obj.cardNumber || '-') + ")"
						} else {
							this.mydialogTitle = "充电记录"
						}
						this.dialogVisible1 = true
					})
				} else if (n == 2) {
					this.$confirm('订单(' + obj.orderId + ')是否确认退款?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.updateRechargeRecord({
							realRechargeTime: obj.realRechargeTime,
							orderId: obj.orderId,
							endReason: obj.endReason,
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '退款成功!'
								});
								this.$nextTick(() => {
									this.getData()
								})
							}
						})
					}).catch(() => {

					});
					// this.timeShow = true
					// this.$nextTick(() => {
					// 	this.$refs.ruleForm4.clearValidate()
					// })
				} else if (n == 3) {
					this.$confirm('是否结束订单(' + obj.orderId + ')?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$api.stopOrder({
							orderId: obj.orderId,
						}).then((res) => {
							if (res.returnCode == 200) {
								that.$message({
									type: 'success',
									message: '订单结束成功!'
								});
								this.$nextTick(() => {
									this.getData()
								})
							}
						})
					}).catch(() => {

					});
				}

			},
			numberChange(val, maxNum, ) {
				//转换数字类型
				let num = Number(val)
				if (num < 0) {
					this.$set(this.creatObj, "realTime", 0)
				}
				if (num > 1000) {
					this.$set(this.creatObj, "realTime", 1000)
				}
			},
			// 按钮保存 新增/编辑
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm4") {
							console.log(this.creatObj)
							that.$api.updateRechargeRecord({
								realRechargeTime: that.creatObj.realTime,
								orderId: that.creatObj.orderId,
								endReason: that.creatObj.endReason,
							}).then((res) => {
								if (res.returnCode == 200) {
									that.$message({
										type: 'success',
										message: '退款成功!'
									});
									this.timeShow = false
									this.$nextTick(() => {
										this.getData()
									})
								}
							})
						}
					}
				});
			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "serviceList", res.obj || [])
					}
				})

			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect(n) {
				// this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}
			},
			getName(val, arr) {
				if (val) {
					let obj = arr.find((item) => {
						return val == item.value
					})
					return obj.text
				} else {
					return ""
				}
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData() {
				this.loading = true
				let obj = {
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
					communityName: this.searchObj.communityName,
					communitySiteId: this.searchObj.communitySiteId,
					search: this.searchObj.search, //用户名称
					orderStatus: this.searchObj.orderStatus,
					orderId: this.searchObj.orderId,
					loginId: this.searchObj.loginId,
					transactionId: this.searchObj.transactionId,
					cardNumber: this.active == 1 ? this.searchObj.cardNumber : "",
					communityEquipmentPort: this.searchObj.communityEquipmentPort,
					communityEquipmentNo: this.searchObj.communityEquipmentNo, //设备编号
					serviceProviderId: this.searchObj.serviceProviderId, //充值类型 1用户充值 2充电反币 3商城反币
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime, //结束时间
					payType: this.active == 1 ? 3 : 2, //结束时间
				}

				this.$api.listRechargeRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						for (let k of res.obj.list || []) {
							k.timeStr = this.gettime(k.realRechargeTime)
						}
						this.$nextTick(() => {
							this.$set(this, "tableData", res.obj.list || [])
						})
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})

			},
			gettime(n) {
				var result = "";
				if (n >= 12) {
					result = 12
				} else {
					let value = parseInt(n * 3600) //总数
					var secondTime = parseInt(value); // 秒
					var minuteTime = 0; // 分
					var hourTime = 0; // 小时
					if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
						//获取分钟，除以60取整数，得到整数分钟
						minuteTime = parseInt(secondTime / 60);
						//获取秒数，秒数取余，得到整数秒数
						secondTime = parseInt(secondTime % 60);
						//如果分钟大于60，将分钟转换成小时
						if (minuteTime > 60) {
							//获取小时，获取分钟除以60，得到整数小时
							hourTime = parseInt(minuteTime / 60);
							//获取小时后取余的分，获取分钟除以60取余的分
							minuteTime = parseInt(minuteTime % 60);
						}
					}
					if (secondTime > 0) {
						result = "" + parseInt(secondTime) + "秒";
					}

					if (minuteTime > 0) {
						result = "" + parseInt(minuteTime) + "分" + result;
					}
					if (hourTime > 0) {
						result = "" + parseInt(hourTime) + "小时" + result;
					}
				}

				// console.log('result', result);
				return result;
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./chargingRecord.scss"
</style>